import { Injectable } from '@angular/core';

import { AutoSub, AutoSubOnDestroy } from './auto-sub';
import { MotesLoginService } from '@motes-sdk/motes-login';
import { MediaService } from './media.service';
import { UserService } from './user.service';

import { Media, MediaType } from '../models';

@AutoSubOnDestroy()
@Injectable({ providedIn: 'root' })
export class ProfileMediaService {

    private readonly predefinedMediaKeys = [
        '-MuBwCvOEOHf9e7mvvmS',
        '-MuBw9eryxfMv_U9rPX9',
        '-MuBw6PkrtGiVvDDaVtq',
        '-MuBw3Ae4JYv3V6vVVzh',
        '-MuBw0AlwJxl1aAlKX2e',
        '-MuBvyQDNF5HFJjjG0e8',
        '-MuBvviiotL4YfYUjiD3',
        '-MuBvsiM0guu7meozDhi',
        '-MuBvqFwO3x3eV_1dVmM',
        '-MuBvnfT8myqSSFqN-yQ',
        '-MuBvl6ulH9pIBbEpPh8',
        '-MuBviPkzoyl532MghBw',
        '-MuBvbVbOpURkhUW614f',
        '-MuBvZIYKuUJXWQutRY1',
        '-MuBvVH10pW-uyvSXy9E'
    ]

    private isInitialized: boolean = false;

    constructor(private mediaService: MediaService, private loginService: MotesLoginService) {
    }

    public init(userService: UserService) {
        if(this.isInitialized) return;
        this.isInitialized = true;
        // Fetch all predefined media from db (for faster load)
        this.predefinedMediaKeys.forEach((key) => {
            this.mediaService.getMedia(key);
        });

        AutoSub(this).reg['loginSub'] = this.loginService.watchLoginResponses().subscribe( async rsp => {
            if(!rsp?.userRights) return;
            // Get user object
            let user = await userService.getUser(rsp.userRights.uid);
            // Do nothing if user already has a profile picture
            if(!user || user.profilePic?.thumb.url) return;

            // Get a predefined profile image
            let predefinedMedia = await this.getPredefinedMedia(user.predefinedProfilePic);
            // Set predefined image on user object
            user.predefinedProfilePic = predefinedMedia.key;
            user.profilePic.thumb.url = predefinedMedia.thumb.url;
            user.profilePic.type = MediaType.IMAGE;
            // Save updated profile image in user
            await userService.updateUser(user);
        });
    }

    public async getPredefinedMedia(currentMediaKey: string): Promise<Media> {
        // If profile pic is already predefined => get next in array. Otherwise get random
        let currentIdx = this.predefinedMediaKeys.findIndex((predefinedKey) => currentMediaKey == predefinedKey);
        let mediaIdx = currentIdx > -1 ? ((currentIdx + 1) % this.predefinedMediaKeys.length) : Math.round(Math.random() * this.predefinedMediaKeys.length);
        // Get predefined media from db
        let mediaKey = this.predefinedMediaKeys[mediaIdx];
        let media = await this.mediaService.getMedia(mediaKey);
        return media;
    }

    public isPredefined(mediaKey: string): boolean {
        return this.predefinedMediaKeys.some((predefinedKey) => mediaKey == predefinedKey);
    }
}
